// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_drawer__q2YGY"};